/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GLD } from "./GLD";
import { GLDFromJSON, GLDFromJSONTyped, GLDToJSON, GLDToJSONTyped } from "./GLD";

/**
 *
 * @export
 * @interface ApiGldGldsList200Response
 */
export interface ApiGldGldsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGldGldsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGldGldsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGldGldsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GLD>}
   * @memberof ApiGldGldsList200Response
   */
  results: Array<GLD>;
}

/**
 * Check if a given object implements the ApiGldGldsList200Response interface.
 */
export function instanceOfApiGldGldsList200Response(
  value: object
): value is ApiGldGldsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGldGldsList200ResponseFromJSON(json: any): ApiGldGldsList200Response {
  return ApiGldGldsList200ResponseFromJSONTyped(json, false);
}

export function ApiGldGldsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGldGldsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GLDFromJSON),
  };
}

export function ApiGldGldsList200ResponseToJSON(json: any): ApiGldGldsList200Response {
  return ApiGldGldsList200ResponseToJSONTyped(json, false);
}

export function ApiGldGldsList200ResponseToJSONTyped(
  value?: ApiGldGldsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GLDToJSON),
  };
}
